<template>
<div v-if="projectUxData && projectUxData.backgroundColor " :style="{backgroundColor: projectUxData && projectUxData.backgroundColor ? projectUxData.backgroundColor : 'initial'}" class="uxdescription-customer">
  <div class="customer-uxdesign-imagediv">
    <img class="customer-uxdesign-image" :src="image">
  </div>
  <div class="customer-uxdesign-textdiv">
    <div style="display: flex">
      <h1  :style="{color: projectUxData && projectUxData.titleColor ? projectUxData.titleColor : 'initial'}" class="customer-ux-title">UX<h1 class="customer-designux-title">DESIGN</h1></h1>
      <img v-if="projectUxData && projectUxData.titleImageAbove" :src="projectUxData.titleImageAbove" class="customer-uxdesign-titleimageabove">
    </div>
    <p v-if="projectUxData && projectUxData.uxDesignText" class="customer-uxdesign-text">{{ projectUxData.uxDesignText }}</p>
    <img v-if="projectUxData && projectUxData.titleImageUnder" :src="projectUxData.titleImageUnder">
  </div>
</div>
</template>
<script>
  export default {
    name: 'CustomerUXDescription',
    data() {
      return {
        image: this.projectUxData && this.projectUxData.uxDesignImage || null
      }
    },
    props: {
      projectUxData: {
        backgroundColor: String,
        titleColor: String,
        uxDesignImage: String,
        uxDesignMobileImage: String,
        titleImageAbove: String,
        uxDesignText: String,
        titleImageUnder: String
      }
    },
    created() {
      this.image = this.projectUxData && this.projectUxData.uxDesignImage ? window.innerWidth > 600 ? this.projectUxData.uxDesignImage : this.projectUxData.uxDesignMobileImage : null
    }
  }

</script>
<style>
  @import "../../assets/scss/customerUXDesign.scss";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerUXDesign.vue